export default __webpack_public_path__ + "static/media/p3.6a152cd1.jpg";